import Header from './landing/Header';
import Footer from './landing/Footer';
import { FaComments, FaArrowRight, FaCheck } from 'react-icons/fa';
import './ProductsPage.css';
import { useScrollReveal } from '../hooks/useScrollReveal';

const chatServeFeatures = [
  'Digital menus, ordering & table booking',
  'AI-powered WebChat available 24/7',
  'Facebook & WhatsApp integration',
  'Instant access via QR code scan',
];

function ProductsPage() {
  useScrollReveal();

  return (
    <div className="site">
      <Header />
      <main className="products-main">
        <section className="products-hero">
          <div className="products-hero-bg" aria-hidden="true">
            <span className="hero-blob hero-blob--1"></span>
            <span className="hero-blob hero-blob--2"></span>
          </div>
          <div className="section-content products-hero-content">
            <h1 className="reveal">
              Software that moves your business forward
            </h1>
            <p className="reveal reveal-delay-1">
              These are the products we&apos;ve built to help businesses serve
              their customers and run day-to-day operations more smoothly.
            </p>
          </div>
        </section>

        <section className="products-section section">
          <div className="section-content">
            <div className="product-grid">
              <a
                href="https://restaurants.chatserve.eu/for-restaurants"
                className="product-card reveal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="product-card-top">
                  <div className="product-card-icon" aria-hidden="true">
                    <FaComments />
                  </div>
                  <span className="product-card-tag">Live product</span>
                </div>

                <h2 className="product-card-title">ChatServe</h2>
                <p className="product-card-subtitle">
                  Elevate your guest experience &amp; streamline operations
                </p>
                <p className="product-card-text">
                  ChatServe is a platform built for restaurants and bars.
                  Guests browse the menu, place orders and book tables through
                  one digital interface, and an AI assistant answers their
                  questions around the clock.
                </p>

                <ul className="product-card-features">
                  {chatServeFeatures.map((feature) => (
                    <li key={feature}>
                      <FaCheck className="product-card-check" aria-hidden="true" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <span className="product-card-cta">
                  Learn more &amp; get started
                  <FaArrowRight aria-hidden="true" />
                  <span className="sr-only"> (opens in a new tab)</span>
                </span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ProductsPage;
